export default __webpack_public_path__ + "static/media/4.63c483a4.jpg";